import React, { FC, HTMLAttributes } from 'react'

import clsx from 'clsx'

export interface TextProps extends HTMLAttributes<HTMLParagraphElement> {
  theme?: 'bold' | 'base' | 'emphasis' | 'sm' | 'muted' | 'label' | 'medium'
  as?: 'i' | 'u' | 'abbr' | 'cite' | 'del' | 'em' | 'ins' | 'kbd' | 'mark' | 's' | 'samp' | 'sub' | 'sup' | 'p' | 'span'
  alternative?: boolean
}

export const TextStyle = {
  theme: {
    bold: 'font-bold',

    default: '',
    // (should this just replace the bold theme?)
    label: 'font-mono uppercase text-sm',
    medium: 'font-medium',
    mono: 'font-mono',
    muted: 'sm text-text-alternative',
    sm: 'text-sm'
  }
}

// Please do not use types off of a default export module or else Storybook Docs will suffer.
// see: https://github.com/storybookjs/storybook/issues/9556
/**
 * Text - Basic text element implementing `body` text styles
 * https://www.figma.com/file/JoOzcZfzFEfLf7LvLShaINKI/Component-Library?node-id=191%3A41
 */
export const Text: FC<TextProps> = React.forwardRef<HTMLParagraphElement, TextProps>(
  ({ alternative = false, as = 'div', children, className, theme = 'default', ...props }, ref) => {
    return React.createElement(
      as,
      {
        ...props,
        className: clsx(className, TextStyle.theme[theme], alternative ? 'text-text-alternative' : 'text-text-default'),
        ref
      },
      children
    )
  }
)
